<template>
	<div class="pa-2">
		<h5 class="headline mb-4">Pay To JEET 11 User</h5>
		<v-btn fab flat class="top-right-align" @click="closeModal">
			<v-icon>close</v-icon>
		</v-btn>
		<div v-if="!jeet11User">No content</div>
		<div v-else>
			<v-layout wrap class="mb-4">
				<v-flex class="mr-5" xs12 md4 lg4>
					<div class="subheader">Mobile Number</div>
					<strong class="headline">{{ jeet11User.phoneNo }}</strong>
				</v-flex>
				<v-flex xs12 md4 lg3>
					<div class="subheader">TeamName</div>
					<strong class="headline">{{ jeet11User.teamName }}</strong>
				</v-flex>
			</v-layout>
			<v-layout class="mb-2">
				<v-flex xs12 md4 lg3>
					<v-text-field
						label="Amount"
						v-model="amount"
						prepend-icon="account_balance_wallet"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout mb-4>
				<v-flex xs12 md4 lg3>
					<v-text-field
						label="Enter mPin"
						v-model="mPin"
						@keyup.enter="confirmAndPayToUser"
						placeholder="* * * *"
						:disabled="!amount"
						type="password"
					></v-text-field>
				</v-flex>
				<v-flex class="allCenteredChild">
					<v-btn
						outline
						:color="themeInputColor"
						small
						:disabled="payingJeet11User"
						@click="forgetMpin()"
						>Set/Reset mPin ?</v-btn
					>
				</v-flex>
			</v-layout>
			<v-layout>
				<v-btn
					class="mx-0 mr-4 white--text"
					:color="themeInputColor"
					:loading="payingJeet11User"
					@click="confirmAndPayToUser"
					:disabled="!amount || !mPin"
					>Confirm</v-btn
				>
				<v-btn color="error" outline @click="closeModal">Cancel</v-btn>
			</v-layout>
		</div>
	</div>
</template>

<script>
export default {
	name: "TransferMoney",
	props: [
		"themeInputColor",
		"jeet11User",
		"payingJeet11User",
		"forgetMpin",
		"model",
		"confirmAndPayJeet11User"
	],
	data() {
		return {
			amount: null,
			mPin: null
		};
	},
	methods: {
		resetData() {
			this.amount = null;
			this.mPin = null;
		},
		confirmAndPayToUser() {
			this.confirmAndPayJeet11User({
				amount: Math.round(Number(this.amount) * 100) / 100,
				userId: this.jeet11User.userId,
				mPin: this.mPin
			}).then(() => {
				this.resetData();
			});
		},
		closeModal() {
			this.resetData();
			this.$emit("CLOSE_MODAL", this.model);
		}
	}
};
</script>

<style lang="scss" scoped>
.subheader {
	font-size: 18px;
	color: grey;
}
</style>
